import React from 'react';
import { StyledRow, HalfColumn, MediumColumn, StyledBlueButton } from '../../../../shared/sharedStyles.styles';
import {
  ContainerGray,
  AnalythicList,
  AnalythicLine,
  LineTitle,
  ColoredSpan,
  RiskText
} from '../../analythic.styled';
import { ColoredColumn, TableTitle, Line } from '../styled';

import { acoesCnjReuResume, getResultObj } from '../products/fcAnalise';
import LawsuitInfos from './LawsuitInfos';

import ReactTooltip from 'react-tooltip'
import TourTooltip from '../../../../shared/TourTooltip';

// import { ResumeButton } from "./../../pages/operational/request/resume/requestResume.styles";

const LawsuitsCiveis = ({ dataSource, hidenTitle, handleVisibleCnjReu, isVisibleCnjReu, isPJ, pretendente }) => {
  const source = getResultObj(dataSource, 'restricoes_financeiras');

  console.log("sourcexx1", source)
  if(source !== undefined && !('acoes_outros_cnj_reu' in source)) {
    return null;
  }
  
  if (source !== undefined && "acoes_outros_cnj_reu" in source && !source.acoes_outros_cnj_reu.detalhes.length) {
    return (
      <ContainerGray margin="0 0 8px 0" className="acoes-despejo">
        <StyledRow customStyle="height: auto" justify="flex-start">
            <HalfColumn>
              <TableTitle style={{display: hidenTitle ? 'none' : 'block', color: '#000'}} className={`acoes_outros_cnj_reu data-p-${pretendente.id}`}>Outras AÇÕES do CNJ (Réu)*</TableTitle>
            </HalfColumn>
            <HalfColumn>
              <TableTitle style={{color: '#000'}}>NÃO ENCONTRADO*</TableTitle>
            </HalfColumn>
            {/* <RiskText style={{fontStyle: 'italic', fontSize: 13}}>*Buscas automatizadas que dependem da abrangência e disponibilidade das fontes. Podem não refletir a totalidade de apontamentos do pesquisado.</RiskText> */}
        </StyledRow>
      </ContainerGray>
    )
  } else if(source !== undefined && !('acoes_outros_cnj_reu' in source)) {
    return null
  }

  const renderDataLine = ({ title, data }) => (
    <AnalythicLine key={(title + data)}>
      <LineTitle maxWidth="205px" style={{color: '#000'}}>{title}</LineTitle>
      <ColoredSpan color='color_black'>{data}</ColoredSpan>
    </AnalythicLine>
  );

  const renderResumeLines = (keys) => {
    const dataGiven = acoesCnjReuResume(dataSource, keys);
    return dataGiven.map((line) => renderDataLine(line));
  };

  return (
    <ColoredColumn>
      <TableTitle style={{display: hidenTitle ? 'none' : 'block', color: '#000'}} className={`acoes_outros_cnj_reu data-p-${pretendente.id}`}>Outras AÇÕES do CNJ (Réu)*</TableTitle>
      {/* <RiskText style={{fontStyle: 'italic', fontSize: 13}}>*Buscas automatizadas que dependem da abrangência e disponibilidade das fontes. Podem não refletir a totalidade de apontamentos do pesquisado.</RiskText> */}
      <StyledRow align="initial" margin="0 0 .5rem 0">
        <MediumColumn>
          <ContainerGray>
            <AnalythicList>
              {renderResumeLines(['total_ocorrencias_acoes'])}
            </AnalythicList>
          </ContainerGray>
        </MediumColumn>
        <MediumColumn>
          <ContainerGray>
            <AnalythicList>
              {renderResumeLines(['data_primeira_ocorrencia'])}
            </AnalythicList>
          </ContainerGray>
        </MediumColumn>
        <MediumColumn>
          <ContainerGray>
            <AnalythicList>
              {renderResumeLines(['data_ultima_ocorrencia'])}
            </AnalythicList>
          </ContainerGray>
        </MediumColumn>
      </StyledRow>
      <Line />
      <TableTitle style={{marginBottom: 20, color: '#000'}}>
        DETALHAMENTO (MAIS RECENTES - ATÉ 20)
        <div onClick={handleVisibleCnjReu} style={{marginLeft: 8, padding: 6, cursor: 'pointer', display: 'inline-block', transform: isVisibleCnjReu ? 'rotate(180deg)' : 'rotate(0deg)'}}>
          ⌵
        </div>
        <span style={{fontSize: 12, fontWeight: 500, position: 'relative'}}>
          <StyledBlueButton onClick={handleVisibleCnjReu} customStyle='background-color: #ff7200;'>{isVisibleCnjReu ? 'Recolher Detalhes' : 'Ver Detalhes'}</StyledBlueButton>
          <TourTooltip
            target="tooltip-btn-ver-detalhes-cnj-reu"
            style={{right: -10, top: -15}}
          />
          <ReactTooltip id="tooltip-btn-ver-detalhes-cnj-reu" place="top" type="dark" effect="float">
            Clique para visualizar o detalhamento e para aparecer na impressão/PDF.
          </ReactTooltip>
        </span>
      </TableTitle>
      {isVisibleCnjReu && source.acoes_outros_cnj_reu && source.acoes_outros_cnj_reu.detalhes.map((acao, index) => 
          <LawsuitInfos index={index} acoesLength={source.acoes_outros_cnj_reu.detalhes.length} acao={acao} tipoAcao='cnjReu' isPJ={isPJ} color='color_black' />
      )}
      {/* <RiskText>*Captura complementar e com abrangência limitada.</RiskText> */}
    </ColoredColumn>
  )
};

export default LawsuitsCiveis;